import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default, { useRef, useState, useEffect } from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';
import useCanvasId from '../utils/useCanvasId.js';

var _excluded = ["className"],
  _excluded2 = ["className", "emphasized", "size", "id"],
  _excluded3 = ["className", "emphasized", "height"],
  _excluded4 = ["className", "data-testid", "emphasized", "height", "id"];
var Placeholder = function Placeholder(_ref) {
  var className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-Placeholder', className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: finalClasses,
    "aria-busy": "true",
    "aria-label": "Loading, please wait",
    role: "status"
  }, otherProps));
};
Placeholder.displayName = 'Placeholder';
var PlaceholderCircle = function PlaceholderCircle(_ref2) {
  var className = _ref2.className,
    _ref2$emphasized = _ref2.emphasized,
    emphasized = _ref2$emphasized === void 0 ? false : _ref2$emphasized,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'normal' : _ref2$size;
    _ref2.id;
    var otherProps = _objectWithoutProperties(_ref2, _excluded2);
  alertUserOfDeprecatedProps('PlaceholderCircle', otherProps);
  var finalClasses = classnames('C-Placeholder__Item', '--type-circle', _defineProperty({
    '--emphasized': emphasized
  }, "--size-".concat(size), size), className);
  return /*#__PURE__*/React__default.createElement("span", _extends({
    className: finalClasses,
    "aria-hidden": "true",
    focusable: "false"
  }, otherProps));
};
PlaceholderCircle.displayName = 'Placeholder.Circle';
Placeholder.Circle = PlaceholderCircle;
var PlaceholderRect = function PlaceholderRect(_ref3) {
  var className = _ref3.className,
    _ref3$emphasized = _ref3.emphasized,
    emphasized = _ref3$emphasized === void 0 ? false : _ref3$emphasized,
    _ref3$height = _ref3.height,
    height = _ref3$height === void 0 ? '100px' : _ref3$height,
    otherProps = _objectWithoutProperties(_ref3, _excluded3);
  var finalClasses = classnames('C-Placeholder__Item', '--type-rect', {
    '--emphasized': emphasized
  }, className);
  return /*#__PURE__*/React__default.createElement("span", _extends({
    className: finalClasses,
    style: {
      height: height
    },
    "aria-hidden": "true",
    focusable: "false"
  }, otherProps));
};
PlaceholderRect.displayName = 'Placeholder.Rect';
Placeholder.Rect = PlaceholderRect;
var PlaceholderText = function PlaceholderText(_ref4) {
  var className = _ref4.className,
    dataTestId = _ref4['data-testid'],
    _ref4$emphasized = _ref4.emphasized,
    emphasized = _ref4$emphasized === void 0 ? false : _ref4$emphasized,
    _ref4$height = _ref4.height,
    height = _ref4$height === void 0 ? '16px' : _ref4$height,
    id = _ref4.id,
    otherProps = _objectWithoutProperties(_ref4, _excluded4);
  var finalClasses = classnames('C-Placeholder__Item', '--type-text', {
    '--emphasized': emphasized
  });
  var containerRef = useRef({});
  var _containerRef$current = containerRef.current.clientHeight,
    clientHeight = _containerRef$current === void 0 ? 0 : _containerRef$current;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    numLines = _useState2[0],
    setNumLines = _useState2[1];
  useEffect(function () {
    // useEffect makes sure we set the numLines after the div with specified height has rendered
    setNumLines(Math.floor(clientHeight / 21) || 1);
  }, [clientHeight, otherProps]);
  var GetTextBars = function GetTextBars() {
    var barArray = [];
    var prefix1 = useCanvasId(id, 'TextBar');
    // useId can't be in a loop or in conditions
    // see docs: https://react.dev/reference/react/useId
    for (var index = 0; index < numLines; index++) {
      // if this is the last bar and there are multiple bars, shorten it
      if (numLines > 1 && index === numLines - 1) {
        barArray.push( /*#__PURE__*/React__default.createElement(TextBar, {
          key: "".concat(prefix1).concat(index),
          index: index,
          style: {
            width: '78%'
          }
        }));
      } else {
        barArray.push( /*#__PURE__*/React__default.createElement(TextBar, {
          key: "".concat(prefix1).concat(index),
          index: index
        }));
      }
    }
    return barArray;
  };
  var TextBar = function TextBar(_ref5) {
    var index = _ref5.index,
      style = _ref5.style;
    return /*#__PURE__*/React__default.createElement("span", _extends({
      style: style,
      className: finalClasses,
      "data-testid": dataTestId ? "TextBar_0".concat(index, "_").concat(dataTestId) : '',
      "aria-hidden": "true",
      focusable: "false"
    }, otherProps));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": dataTestId,
    style: {
      height: height
    },
    ref: containerRef,
    className: "C-Placeholder__ItemContainer ".concat(className ? className : ''),
    children: GetTextBars()
  });
};
PlaceholderText.displayName = 'Placeholder.Text';
Placeholder.Text = PlaceholderText;

export { PlaceholderCircle, PlaceholderRect, Placeholder as default };
